import { render, staticRenderFns } from "./CollaboratorPriceTableCreateUpdate.vue?vue&type=template&id=4b67a168&scoped=true&"
import script from "./CollaboratorPriceTableCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CollaboratorPriceTableCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorPriceTableCreateUpdate.vue?vue&type=style&index=0&id=4b67a168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b67a168",
  null
  
)

export default component.exports